<template>
  <div class="t-s" ref="TextScrollBox">
    <span ref="TextScrollValue">
      <template v-if="boxWidth<valWidth">
        <marquee scrollamount="4">
          {{ value }}
        </marquee>
      </template>
      {{ value }}
    </span>

  </div>
</template>

<script>
export default {
  name: "TextScroll",
  props: {
    trTextSize: {
      type: Number,
      default: 16
    },
    value: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      boxWidth: 0,
      valWidth: 0
    }
  },
  updated() {
    this.boxWidth = this.$refs.TextScrollBox.offsetWidth;
    this.valWidth = this.$refs.TextScrollValue.offsetWidth;
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.boxWidth = this.$refs.TextScrollBox.offsetWidth;
  //     this.valWidth = this.$refs.TextScrollValue.offsetWidth;
  //   }, 6000);
  // },
  // methods: {},
}
</script>

<style lang="scss" scoped>
.t-s {
  // width: 100%;
  white-space: nowrap; /* 不换行 */
}
</style>